import { OrderedEnumerable } from "../OrderedEnumerable.js";
export const orderByAsync = (source, keySelector, comparer) => {
    return OrderedEnumerable.generateAsync(source, keySelector, true, comparer);
};
